import styled from '@emotion/styled';

export const ViewContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
`;
